import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ActiveCallsRegister } from '../../active-calls-register';
import { ActiveCallsFilterOptions } from '../../models/active-calls-filter-option';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import * as AccountActiveCallsActions from '../../state/account-active-calls/account-active-calls.actions';
import * as accountActiveCallsRegisterReducer from '../../state/account-active-calls/account-active-calls.reducer';
import { selectSortedActiveCalls } from '../../state/account-active-calls/account-active-calls.selectors';
@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-account-active-calls-register',
   templateUrl: './account-active-calls-register.component.html',
   standalone: false,
})
export class AccountActiveCallsRegisterComponent extends ActiveCallsRegister {
   constructor(public store: Store) {
      super(
         store,
         accountActiveCallsRegisterReducer.selectors,
         AccountActiveCallsActions.accountActiveCallsRegisterAdapterActions
      );
      this.dataSource$ = this.store.pipe(select(selectSortedActiveCalls));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: ActiveCallsFilterOptions[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = [
         'callDirection',
         'callSource',
         'callDestination',
         'sourceProvider',
         'destinationProvider',
         'callDuration',
         'activeCallsActionsMenu',
      ];
   }

   onOpenDialog(event: { callLogs: any }) {
      this.store.dispatch(AccountActiveCallsActions.openDialog(event));
   }

   onHangupActiveCall(event: { activeCall: ActiveCallsRegisterListItem }) {
      this.store.dispatch(AccountActiveCallsActions.hangupActiveCall(event));
   }

   getInitialFilterAction() {
      return AccountActiveCallsActions.accountActiveCallsRegisterInitialFilter({ filters: this.filters });
   }
   getCreateAction() {
      return AccountActiveCallsActions.createActiveCalls();
   }
}
